import LBox from "@components/LBox";
import LIcon from "@components/LIcon";
import LText from "@components/LText";
import { FadeInDown } from "react-native-reanimated";

const YoureIn = ({ isWaitlist }: { isWaitlist: boolean }) => {
  return (
    <LBox
      padding="s4"
      borderRadius="m-l"
      backgroundColor="whiteTranslucent10"
      gap="s2"
      entering={FadeInDown}
    >
      <LBox flexDirection="row" alignItems="center" gap="s2">
        <LIcon name="tick_circle" size={24} />
        <LText variant="Heading/H2/Medium" color="white">
          {isWaitlist ? "You're on the waitlist!" : "You're in!"}
        </LText>
      </LBox>
      <LText variant="Body/B2/Regular" color="whiteTranslucent70">
        {isWaitlist
          ? "We'll notify you if a ticket becomes available. Check your email for details."
          : "Check your email to manage your registration and access your ticket."}
      </LText>
    </LBox>
  );
};

export default YoureIn;
